import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import usePageMeta from "../hooks/usePageMeta";
import Footer from "../components/Footer";
import { ArrowLeft, Search } from "lucide-react";

export default function NotFound() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("notFound.title"),
    description: t("notFound.description"),
    path: "/404",
  });

  return (
    <>
      <section className="relative overflow-hidden page-header pt-40 tablet:pt-36 mobile:pt-32 pb-24 tablet:pb-20 px-6 mobile:px-4">
        <div
          className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,#000_25%,transparent_70%)]"
          aria-hidden="true"
        ></div>
        <div className="relative container-page">
          <span className="kicker mb-4 animate-fade-in">404</span>
          <h1 className="text-5xl tablet:text-4xl mobile:text-3xl font-semibold tracking-[-0.02em] text-black leading-[1.05] max-w-3xl mb-4 animate-slide-up">
            {t("notFound.title")}
          </h1>
          <p className="text-lg tablet:text-base text-gray-700 leading-relaxed max-w-[60ch] mb-10">
            {t("notFound.description")}
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-textBlue text-white text-sm font-medium px-6 py-3 rounded-full hover:bg-textBlueDark transition-colors no-underline focus-visible:ring-2 focus-visible:ring-textBlue focus-visible:ring-offset-2"
            >
              <ArrowLeft className="w-4 h-4" aria-hidden="true" />
              {t("notFound.home")}
            </Link>
            <Link
              to="/solutions"
              className="inline-flex items-center gap-2 border border-line bg-white text-textBlueDark text-sm font-medium px-6 py-3 rounded-full hover:border-textBlue hover:text-textBlue transition-colors no-underline focus-visible:ring-2 focus-visible:ring-textBlue focus-visible:ring-offset-2"
            >
              <Search className="w-4 h-4" aria-hidden="true" />
              {t("notFound.solutions")}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
